export function betterParseFloat(v: unknown): number | undefined {
  if (v === undefined || v === null) return undefined;
  if (typeof v === 'number') return v;
  const parsed = String(v).replaceAll(/[^0-9\\.]/g, '');
  if (parsed === '') return undefined;
  return parseFloat(parsed);
}
